import { memo } from 'react';

const TileWrapper = ({ children, containerClasses = '', tileClasses = '' }) => (
	<div className={`flex flex-wrap justify-center lg:justify-start px-1.5 sm:px-2.5 ${containerClasses}`}>
		{children}
		{/* Empty tiles for keeping the last tiles left aligned */}
		<div className={`flex w-1/2 h-0 max-w-tile-mobile sm:max-w-tile xl:w-1/3 2xl:w-1/4 ${tileClasses}`} />
		<div className={`flex w-1/2 h-0 max-w-tile-mobile sm:max-w-tile xl:w-1/3 2xl:w-1/4 ${tileClasses}`} />
		<div className={`flex w-1/2 h-0 max-w-tile-mobile sm:max-w-tile xl:w-1/3 2xl:w-1/4 ${tileClasses}`} />
	</div>
);

// TODO: Wann immer memo?
export default memo(TileWrapper);
